// extracted by mini-css-extract-plugin
export default {"container":"DialogBase_container__+nBrd","closeButton":"DialogBase_closeButton__Uikui"};